module.exports = __webpack_public_path__ + "img/gi.178e56f2.svg";